var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-footer"},[_vm._v(" © 2020 Karki, spol. s r.o., Všetky práva vyhradené. ")])}
var staticRenderFns = []

export { render, staticRenderFns }